import React from 'react';
import Typography from '@material-ui/core/Typography';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import './Breadcrumb.scss';

const useStyles = makeStyles((theme) => ({
  primary: {
    color: (props) =>
      props.color === undefined ? theme.palette.primary.main : props.color,
    fontWeight: 'bold',
    '&:hover': {
      textDecoration: 'none',
      color: theme.palette.primary.main
    }
  },
  primaryStatic: {
    color: (props) =>
      props.color === undefined ? theme.palette.primary.main : props.color,
    fontWeight: 'bold'
  },
  blackTitle: {
    color:"black",
    fontWeight:600,
    '&:hover': {
      color:"black",
      textDecoration: 'none',
      fontWeight:600
    }
  }
}));

export default function Breadcrumb(props) {

  const { breadcrumbLinks, currentPage } = props;

  const classes = useStyles();

  return (
    <Breadcrumbs>
      {breadcrumbLinks.map((v, index) => {

        if (!v.name) {
          return null;
        }

        return (
          <Link to={v.href} onClick={v.onClick} className={props.showBlackBreadcumb ? classes.blackTitle : classes.primary } key={index}>
            {v.name}
          </Link>
        )
      })}
      {
        currentPage ?
        <Typography className={props.showBlackBreadcumb ? classes.blackTitle : classes.primaryStatic}>{currentPage}</Typography>
        : 
        null
      }
    </Breadcrumbs>
  );
};

Breadcrumb.propTypes = {
  breadcrumbLinks: PropTypes.array.isRequired,
  currentPage: PropTypes.string.isRequired
}


// WEBPACK FOOTER //
// ./src/components/Common/Breadcrumb/Breadcrumb.js